import { ThemeColor } from "./props";
import {
  mdiAlert,
  mdiCheckCircle,
  mdiAlertOctagonOutline,
  mdiCheckBold,
  mdiExclamationThick,
  mdiCloseThick,
  mdiCheckboxBlankCircleOutline,
  mdiInformationOutline,
} from "@mdi/js";

export const NULL_DATETIME_PATTERN = /^0001-01-01T/g;

export const INDEFINITE_DATETIME_ISO = "9999-12-31T00:00:00Z";

export enum ValueType {
  TEXT = "text",
  DATE = "date",
  LOCALDATE = "localdate",
  DATERANGE = "date-range",
  TIME = "time",
  DATETIME = "datetime",
  BOOL = "bool",
  OBJECT = "object",
  LOCALIZED = "localized",
}

export enum FieldType {
  OBJECT = "object",
  DIALOG = "dialog",
  SELECT = "select",
  SELECT_MULTI = "select-multi",
  ORDERING = "ordering",
  TIME = "time",
  DATE = "date",
  DATERANGE = "daterange",
  DATETIME = "datetime",
  BOOL = "bool",
  TERMS = "terms",
  TEXT = "text",
  TEXTAREA = "textarea",
  INTEGER = "integer",
  FLOAT = "float",
  FILE_UPLOAD = "file-upload",
  JSON = "json",
  CUSTOM = "custom",
}

export const fieldTypes = {
  OBJECT: "object",
  DIALOG: "dialog",
  SELECT: "select",
  SELECT_MULTI: "select-multi",
  ORDERING: "ordering",
  TIME: "time",
  DATE: "date",
  DATERANGE: "daterange",
  DATETIME: "datetime",
  BOOL: "bool",
  TERMS: "terms",
  TEXT: "text",
  TEXTAREA: "textarea",
  INTEGER: "integer",
  FLOAT: "float",
  FILE_UPLOAD: "file-upload",
  JSON: "json",
  CUSTOM: "custom",
};

export const DATE_RANGE_BEGIN = "begin";
export const DATE_RANGE_END = "end";

export const FIELD_TYPE_OBJECT = FieldType.OBJECT;
export const FIELD_TYPE_DIALOG = FieldType.DIALOG;
export const FIELD_TYPE_SELECT = FieldType.SELECT;
export const FIELD_TYPE_SELECT_MULTI = FieldType.SELECT_MULTI;
export const FIELD_TYPE_ORDERING = FieldType.ORDERING;
export const FIELD_TYPE_TIME = FieldType.TIME;
export const FIELD_TYPE_DATE = FieldType.DATE;
export const FIELD_TYPE_DATERANGE = FieldType.DATERANGE;
export const FIELD_TYPE_DATETIME = FieldType.DATETIME;
export const FIELD_TYPE_BOOL = FieldType.BOOL;
export const FIELD_TYPE_TERMS = FieldType.TERMS;
export const FIELD_TYPE_TEXT = FieldType.TEXT;
export const FIELD_TYPE_TEXTAREA = FieldType.TEXTAREA;
export const FIELD_TYPE_INTEGER = FieldType.INTEGER;
export const FIELD_TYPE_FLOAT = FieldType.FLOAT;
export const FIELD_TYPE_FILE_UPLOAD = FieldType.FILE_UPLOAD;
export const FIELD_TYPE_JSON = FieldType.JSON;
export const FIELD_TYPE_CUSTOM = FieldType.CUSTOM;

export const ThemeColorIcons = {
  [ThemeColor.none]: mdiInformationOutline,
  [ThemeColor.transparent]: mdiInformationOutline,
  [ThemeColor.primary]: mdiInformationOutline,
  [ThemeColor.secondary]: mdiInformationOutline,
  [ThemeColor.gray]: mdiInformationOutline,
  [ThemeColor.error]: mdiAlertOctagonOutline,
  [ThemeColor.warning]: mdiAlert,
  [ThemeColor.success]: mdiCheckCircle,
  [ThemeColor.danger]: mdiCloseThick,
  [ThemeColor.alert]: mdiExclamationThick,
  [ThemeColor.done]: mdiCheckBold,
};
